import {
  createContext,
  useContext,
  useRef,
  useState,
  useCallback,
} from "react";
import useLocalStorage from "./useLocalStorage";

const CurrentPlayingContext = createContext();

export default function CurrentPlayingStation({ children }) {
  const [currentStation, setCurrentStation] = useLocalStorage(
    "currentStation",
    {}
  );

  const [audioPlayerValue, setAudioPlayerValue] = useState("");

  const audioPlayerRef = useCallback((node) => {
    if (node !== null && node !== "") {
      setAudioPlayerValue(node);
    }
  }, []);

  const value = {
    currentStation,
    setCurrentStation,
    audioPlayerValue,
    audioPlayerRef,
  };

  return (
    <CurrentPlayingContext.Provider value={value}>
      {children}
    </CurrentPlayingContext.Provider>
  );
}

// export const useCurrentPlayingContext = () => {
//   return useContext(CurrentPlayingContext);
// };
export function useCurrentPlayingContext() {
  const context = useContext(CurrentPlayingContext);
  if (!context) {
    throw new Error(
      "useCurrentPlayingContext must be used within a CurrentStationContextWrapper"
    );
  }
  return context;
}
